/*=============================================== Nav component ===============================================*/

import { useContext } from "react"
import { NavLink } from "react-router-dom"
import classNames from "classnames"
import { unslugify } from "tsx-library-julseb"

import { ModalContext } from "context"
import type { ModalContextType } from "context"

import { NavList } from "components/layouts/NavList"

import { StyledNav, StyledButton } from "components/layouts/Nav/styles"
import type { NavProps } from "components/layouts/Nav/types"

import { navItems, categoryItems } from "data"

const Nav = ({ isOpen, setIsOpen }: NavProps) => {
    const { isModalOpen } = useContext(ModalContext) as ModalContextType

    return (
        <>
            <StyledButton
                icon={isOpen ? "chevron-left" : "chevron-right"}
                size={24}
                className={classNames(
                    { open: isOpen },
                    { "modal-open": isModalOpen }
                )}
                onClick={() => setIsOpen(!isOpen)}
            />

            <StyledNav
                className={classNames(
                    { open: isOpen },
                    { "modal-open": isModalOpen }
                )}
            >
                {navItems.map(item => (
                    <NavLink to={item} key={item}>
                        {item === "/"
                            ? "Home"
                            : unslugify(item.replace("/", ""))}
                    </NavLink>
                ))}

                {categoryItems.map(category => (
                    <NavList category={category} key={category} />
                ))}
            </StyledNav>
        </>
    )
}

export default Nav
